import React from "react";
import { Hero } from "../components/Hero";
import { Ticker } from "../components/Ticker";
import { Flavors } from "../components/Flavors";
import { CoffeeClub } from "../components/CoffeeClub";

export default function Landing({ onJoin }) {
  return (
    <main>
      <Hero />
      <Ticker />
      <Flavors onJoin={onJoin} />
      <CoffeeClub onOpenClub={onJoin} />
    </main>
  );
}
